import gql from "graphql-tag"

const GET_CUSTOM_GIFT_CARD_CONFIG = gql`
  query getBSGGiftCardConfig($id: ID!) {
    getBSGGiftCardConfig(id: $id) {
      id
      baseUrl
      tokenUrl
      scopes
      credentials {
        clientId
        clientSecret
      }
      created
      updated
    }
  }
`

export default GET_CUSTOM_GIFT_CARD_CONFIG
